import { render, staticRenderFns } from "./info-overlay.vue?vue&type=template&id=88681346&scoped=true&"
import script from "./info-overlay.vue?vue&type=script&lang=ts&"
export * from "./info-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./info-overlay.vue?vue&type=style&index=0&id=88681346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88681346",
  null
  
)

export default component.exports